/*!
  * pinia v2.0.0-alpha.2
  * (c) 2020 Eduardo San Martin Morote
  * @license MIT
  */
import { ref, watch, computed, reactive } from 'vue';

function isPlainObject(
// eslint-disable-next-line @typescript-eslint/no-explicit-any
o) {
    return (o &&
        typeof o === 'object' &&
        Object.prototype.toString.call(o) === '[object Object]' &&
        typeof o.toJSON !== 'function');
}

/**
 * setActiveReq must be called to handle SSR at the top of functions like `fetch`, `setup`, `serverPrefetch` and others
 */
let activeReq = {};
const setActiveReq = (req) => req && (activeReq = req);
const getActiveReq = () => activeReq;
/**
 * The api needs more work we must be able to use the store easily in any
 * function by calling `useStore` to get the store Instance and we also need to
 * be able to reset the store instance between requests on the server
 */
const storesMap = new WeakMap();
/**
 * Map of initial states used for hydration
 */
const stateProviders = new WeakMap();
function setStateProvider(stateProvider) {
    stateProviders.set(getActiveReq(), stateProvider);
}
function getInitialState(id) {
    const provider = stateProviders.get(getActiveReq());
    return provider && provider()[id];
}
/**
 * Gets the root state of all active stores. This is useful when reporting an application crash by
 * retrieving the problematic state and send it to your error tracking service.
 * @param req - request key
 */
function getRootState(req) {
    const stores = storesMap.get(req);
    if (!stores)
        return {};
    const rootState = {};
    // forEach is the only one that also works on IE11
    stores.forEach((store) => {
        rootState[store.id] = store.state;
    });
    return rootState;
}
/**
 * Client-side application instance used for devtools
 */
let clientApp;
const setClientApp = (app) => (clientApp = app);
const getClientApp = () => clientApp;
function createPinia() {
    return {
        install(app) {
            setClientApp(app);
        },
    };
}
/**
 * Registered stores
 */
const stores = new Set();
function registerStore(store) {
    stores.add(store);
}
const getRegisteredStores = () => stores;

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function createCommonjsModule(fn, basedir, module) {
	return module = {
		path: basedir,
		exports: {},
		require: function (path, base) {
			return commonjsRequire(path, (base === undefined || base === null) ? module.path : base);
		}
	}, fn(module, module.exports), module.exports;
}

function commonjsRequire () {
	throw new Error('Dynamic requires are not currently supported by @rollup/plugin-commonjs');
}

var env = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });
exports.hook = exports.target = exports.isBrowser = void 0;
exports.isBrowser = typeof navigator !== 'undefined';
exports.target = exports.isBrowser
    ? window
    : typeof commonjsGlobal !== 'undefined'
        ? commonjsGlobal
        : {};
exports.hook = exports.target.__VUE_DEVTOOLS_GLOBAL_HOOK__;

});

var _const = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApiHookEvents = void 0;
var ApiHookEvents;
(function (ApiHookEvents) {
    ApiHookEvents["SETUP_DEVTOOLS_PLUGIN"] = "devtools-plugin:setup";
})(ApiHookEvents = exports.ApiHookEvents || (exports.ApiHookEvents = {}));

});

var api = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });

});

var app = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });

});

var component = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });

});

var context = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });

});

var hooks = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });
exports.Hooks = void 0;
var Hooks;
(function (Hooks) {
    Hooks["TRANSFORM_CALL"] = "transformCall";
    Hooks["GET_APP_RECORD_NAME"] = "getAppRecordName";
    Hooks["GET_APP_ROOT_INSTANCE"] = "getAppRootInstance";
    Hooks["REGISTER_APPLICATION"] = "registerApplication";
    Hooks["WALK_COMPONENT_TREE"] = "walkComponentTree";
    Hooks["WALK_COMPONENT_PARENTS"] = "walkComponentParents";
    Hooks["INSPECT_COMPONENT"] = "inspectComponent";
    Hooks["GET_COMPONENT_BOUNDS"] = "getComponentBounds";
    Hooks["GET_COMPONENT_NAME"] = "getComponentName";
    Hooks["GET_ELEMENT_COMPONENT"] = "getElementComponent";
    Hooks["GET_INSPECTOR_TREE"] = "getInspectorTree";
    Hooks["GET_INSPECTOR_STATE"] = "getInspectorState";
})(Hooks = exports.Hooks || (exports.Hooks = {}));

});

var api$1 = createCommonjsModule(function (module, exports) {
var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(api, exports);
__exportStar(app, exports);
__exportStar(component, exports);
__exportStar(context, exports);
__exportStar(hooks, exports);

});

var lib = createCommonjsModule(function (module, exports) {
var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setupDevtoolsPlugin = void 0;


__exportStar(api$1, exports);
function setupDevtoolsPlugin(pluginDescriptor, setupFn) {
    if (env.hook) {
        env.hook.emit(_const.ApiHookEvents.SETUP_DEVTOOLS_PLUGIN, pluginDescriptor, setupFn);
    }
    else {
        const list = env.target.__VUE_DEVTOOLS_PLUGINS__ = env.target.__VUE_DEVTOOLS_PLUGINS__ || [];
        list.push({
            pluginDescriptor,
            setupFn
        });
    }
}
exports.setupDevtoolsPlugin = setupDevtoolsPlugin;

});

function formatDisplay(display) {
    return {
        _custom: {
            display,
        },
    };
}
let isAlreadyInstalled;
function addDevtools(app, store, req) {
    registerStore(store);
    lib.setupDevtoolsPlugin({
        id: 'pinia',
        label: 'Pinia 🍍',
        app,
    }, (api) => {
        api.on.inspectComponent((payload, ctx) => {
            if (payload.instanceData) {
                payload.instanceData.state.push({
                    type: '🍍 ' + store.id,
                    key: 'state',
                    editable: false,
                    value: store.state,
                });
            }
        });
        // watch(router.currentRoute, () => {
        //   // @ts-ignore
        //   api.notifyComponentUpdate()
        // })
        const mutationsLayerId = 'pinia:mutations';
        const piniaInspectorId = 'pinia';
        if (!isAlreadyInstalled) {
            api.addTimelineLayer({
                id: mutationsLayerId,
                label: `Pinia 🍍`,
                color: 0xe5df88,
            });
            api.addInspector({
                id: piniaInspectorId,
                label: 'Pinia 🍍',
                icon: 'storage',
                treeFilterPlaceholder: 'Search stores',
            });
            isAlreadyInstalled = true;
        }
        else {
            // @ts-ignore
            api.notifyComponentUpdate();
            api.sendInspectorTree(piniaInspectorId);
            api.sendInspectorState(piniaInspectorId);
        }
        store.subscribe((mutation, state) => {
            // rootStore.state[store.id] = state
            const data = {
                store: formatDisplay(mutation.storeName),
                type: formatDisplay(mutation.type),
            };
            if (mutation.payload) {
                data.payload = mutation.payload;
            }
            // @ts-ignore
            api.notifyComponentUpdate();
            api.sendInspectorState(piniaInspectorId);
            api.addTimelineEvent({
                layerId: mutationsLayerId,
                event: {
                    time: Date.now(),
                    data,
                    // TODO: remove when fixed
                    meta: {},
                },
            });
        });
        api.on.getInspectorTree((payload) => {
            if (payload.app === app && payload.inspectorId === piniaInspectorId) {
                const stores = Array.from(getRegisteredStores());
                payload.rootNodes = (payload.filter
                    ? stores.filter((store) => store.id.toLowerCase().includes(payload.filter.toLowerCase()))
                    : stores).map(formatStoreForInspectorTree);
            }
        });
        api.on.getInspectorState((payload) => {
            if (payload.app === app && payload.inspectorId === piniaInspectorId) {
                const stores = Array.from(getRegisteredStores());
                const store = stores.find((store) => store.id === payload.nodeId);
                if (store) {
                    payload.state = {
                        options: formatStoreForInspectorState(store),
                    };
                }
                else {
                    __VUE_DEVTOOLS_TOAST__(`🍍 store "${payload.nodeId}" not found`, 'error');
                }
            }
        });
        // trigger an update so it can display new registered stores
        // @ts-ignore
        api.notifyComponentUpdate();
        __VUE_DEVTOOLS_TOAST__(`🍍 "${store.id}" store installed`);
    });
}
function formatStoreForInspectorTree(store) {
    return {
        id: store.id,
        label: store.id,
        tags: [],
    };
}
function formatStoreForInspectorState(store) {
    const fields = [
        { editable: false, key: 'id', value: formatDisplay(store.id) },
        { editable: true, key: 'state', value: store.state },
    ];
    return fields;
}

const IS_CLIENT = typeof window !== 'undefined';
function innerPatch(target, patchToApply) {
    // TODO: get all keys like symbols as well
    for (const key in patchToApply) {
        const subPatch = patchToApply[key];
        const targetValue = target[key];
        if (isPlainObject(targetValue) && isPlainObject(subPatch)) {
            target[key] = innerPatch(targetValue, subPatch);
        }
        else {
            // @ts-ignore
            target[key] = subPatch;
        }
    }
    return target;
}
function toComputed(refObject) {
    // let asComputed = computed<T>()
    const reactiveObject = {};
    for (const key in refObject.value) {
        // @ts-ignore: the key matches
        reactiveObject[key] = computed({
            get: () => refObject.value[key],
            set: (value) => (refObject.value[key] = value),
        });
    }
    return reactiveObject;
}
/**
 * Creates a store instance
 * @param id - unique identifier of the store, like a name. eg: main, cart, user
 * @param initialState - initial state applied to the store, Must be correctly typed to infer typings
 */
function buildStore(id, buildState = () => ({}), getters = {}, actions = {}, initialState) {
    const state = ref(initialState || buildState());
    // TODO: remove req part?
    const _r = getActiveReq();
    let isListening = true;
    let subscriptions = [];
    watch(() => state.value, (state) => {
        if (isListening) {
            subscriptions.forEach((callback) => {
                callback({ storeName: id, type: '🧩 in place', payload: {} }, state);
            });
        }
    }, {
        deep: true,
        flush: 'sync',
    });
    function patch(partialState) {
        isListening = false;
        innerPatch(state.value, partialState);
        isListening = true;
        // because we paused the watcher, we need to manually call the subscriptions
        subscriptions.forEach((callback) => {
            callback({ storeName: id, type: '⤵️ patch', payload: partialState }, state.value);
        });
    }
    function subscribe(callback) {
        subscriptions.push(callback);
        return () => {
            const idx = subscriptions.indexOf(callback);
            if (idx > -1) {
                subscriptions.splice(idx, 1);
            }
        };
    }
    function reset() {
        subscriptions = [];
        state.value = buildState();
    }
    const storeWithState = {
        id,
        _r,
        // @ts-ignore, `reactive` unwraps this making it of type S
        state: computed({
            get: () => state.value,
            set: (newState) => {
                isListening = false;
                state.value = newState;
                isListening = true;
            },
        }),
        patch,
        subscribe,
        reset,
    };
    const computedGetters = {};
    for (const getterName in getters) {
        computedGetters[getterName] = computed(() => {
            setActiveReq(_r);
            // eslint-disable-next-line @typescript-eslint/no-use-before-define
            return getters[getterName].call(store, store);
        });
    }
    // const reactiveGetters = reactive(computedGetters)
    const wrappedActions = {};
    for (const actionName in actions) {
        wrappedActions[actionName] = function () {
            setActiveReq(_r);
            // eslint-disable-next-line
            return actions[actionName].apply(store, arguments);
        };
    }
    const store = reactive({
        ...storeWithState,
        // using this means no new properties can be added as state
        ...toComputed(state),
        ...computedGetters,
        ...wrappedActions,
    });
    return store;
}
/**
 * Creates a `useStore` function that retrieves the store instance
 * @param options - options to define the store
 */
function createStore(options) {
    const { id, state, getters, actions } = options;
    return function useStore(reqKey) {
        if (reqKey)
            setActiveReq(reqKey);
        const req = getActiveReq();
        let stores = storesMap.get(req);
        if (!stores)
            storesMap.set(req, (stores = new Map()));
        let store = stores.get(id);
        if (!store) {
            stores.set(id, 
            // @ts-ignore
            (store = buildStore(id, state, getters, actions, getInitialState(id))));
            if (IS_CLIENT && (process.env.NODE_ENV !== 'production') /*|| __FEATURE_PROD_DEVTOOLS__*/) {
                const app = getClientApp();
                if (app) {
                    addDevtools(app, store);
                }
                else {
                    console.warn(`[🍍]: store was instantiated before calling\n` +
                        `app.use(pinia)\n` +
                        `Make sure to install pinia's plugin by using createPinia:\n` +
                        `linkto docs TODO`);
                }
            }
        }
        return store;
    };
}

export { createPinia, createStore, createStore as defineStore, getRootState, setActiveReq, setStateProvider };
